class PressTicker extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.press-ticker__track');
    this.source = this.querySelector('.press-ticker__list');
    if (!this.track || !this.source) return;

    this.measure = this.measure.bind(this);

    if ('ResizeObserver' in window) {
      // The source list settles late when a merchant-uploaded <img> replaces an
      // inline SVG, so re-measure on its size rather than only on window resize.
      this.observer = new ResizeObserver(this.debounced(this.measure, 100));
      this.observer.observe(this.source);
      this.observer.observe(this);
    } else {
      window.addEventListener('resize', this.debounced(this.measure, 100));
    }

    this.measure();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  debounced(fn, wait) {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  measure() {
    // The stylesheet hides every copy but the first and drops the animation here,
    // so there is nothing to tile.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const copyWidth = this.source.getBoundingClientRect().width;
    const viewport = this.getBoundingClientRect().width;
    if (!copyWidth || !viewport) return;

    // Two copies only tile seamlessly while one copy is wider than the viewport.
    // Beyond that a copy scrolls clear before the next arrives, so add more.
    const needed = Math.max(2, Math.ceil((viewport * 2) / copyWidth));
    const generated = this.track.querySelectorAll('[data-press-ticker-generated]');

    for (let i = generated.length + 2; i < needed; i++) {
      const clone = this.source.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-press-ticker-generated', '');
      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      this.track.appendChild(clone);
    }
    for (let i = this.track.children.length; i > Math.max(needed, 2); i--) {
      this.track.lastElementChild.remove();
    }

    const copies = this.track.children.length;
    const speed = parseFloat(this.dataset.speed) || 60;
    this.track.style.setProperty('--pt-copies', copies);
    this.track.style.setProperty('--pt-duration', `${copyWidth / speed}s`);
  }
}

if (!customElements.get('press-ticker')) {
  customElements.define('press-ticker', PressTicker);
}
